import axios from "axios"

const MAIN_API_HOST = process.env.REACT_APP_MAIN_API_HOST

export function ShoppingCartItemsApi(props) {
    return {
        searchList: async ({ params, headers, body }) => {
            return await axios.get(`${MAIN_API_HOST}/shopping-cart-items`, {
                params,
                headers
            })
        },
        createList: async ({ params, headers, body }) => {
            return await axios.post(`${MAIN_API_HOST}/shopping-cart-items/create-list`, body, {
                params,
                headers
            })
        },
        patchBatch: async ({ params, headers, body }) => {
            return await axios.patch(`${MAIN_API_HOST}/shopping-cart-items/batch`, body, {
                params,
                headers
            })
        },
        deleteOne: async ({ params, headers, body }) => {
            return await axios.delete(`${MAIN_API_HOST}/shopping-cart-items/${body._id}`, {
                params,
                headers
            })
        },
        deleteByShoppingCartStageId: async ({ params, headers, body }) => {
            return await axios.delete(`${MAIN_API_HOST}/shopping-cart-items/shopping-cart-stages/${body.shoppingCartStageId}`, {
                params,
                headers
            })
        }
    }
}